import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { tabAwareStorage } from "./tab-storage";

interface SiteSelectionState {
  selectedSiteId: string | null;
  selectSite: (id: string) => void;
  clearSelection: () => void;
}

export const useSiteSelection = create<SiteSelectionState>()(
  persist(
    (set) => ({
      selectedSiteId: null,
      selectSite: (id) => set({ selectedSiteId: id }),
      clearSelection: () => set({ selectedSiteId: null }),
    }),
    {
      name: "site-selection",
      storage: createJSONStorage(() => tabAwareStorage),
    },
  ),
);
